import { CalendarOutlineIcon } from 'assets/icons/CalendarOutlineIcon'
import { GBPInCircleIcon } from 'assets/icons/GBPInCircleIcon'
import { MapMarkerIcon } from 'assets/icons/MapMarkerIcon'
import { ShareholderIcon } from 'assets/icons/ShareholderIcon'
import { TwoPeopleIcon } from 'assets/icons/TwoPeopleIcon'
import { InnovateUKLogoIcon } from 'assets/icons/InnovateUKLogoIcon'
import { SeedrsLogoIcon } from 'assets/icons/SeedrsLogoIcon'
import { UKFlagIcon } from 'assets/icons/UKFlagIcon'

const listStyle = 'space-y-6 lg:space-y-0 text-xs font-medium text-[#101828] lg:flex lg:flex-row'
const itemStyle = 'flex items-center gap-2 text-xs md:text-sm xl:text-base 3xl:text-[24px]'

export const Section1Lists = () => {
  return (
    <div className='flex flex-col gap-10 sm:flex-row sm:items-center sm:gap-30 sm:justify-center lg:flex-col lg:gap-10 3xl:py-10'>
      {/* List 1 */}
      <ul className={`${listStyle} py-3 lg:gap-5 3xl:gap-12`}>
        <li className={itemStyle}>
          <MapMarkerIcon className='xl:w-6 h-6' />
          Established August 2017
        </li>
        <li className={itemStyle}>
          <GBPInCircleIcon className='xl:w-6 h-6' />
          £1.3M funded
        </li>
        <li className={itemStyle}>
          <CalendarOutlineIcon className='xl:w-6 h-6' />
          7 years old
        </li>
        <li className={itemStyle}>
          <ShareholderIcon className='xl:w-6 h-6' />
          263 Shareholders
        </li>
        <li className={itemStyle}>
          <TwoPeopleIcon className='xl:w-6 h-6' />
          250,000 registered users
        </li>
      </ul>
      {/* List 2 */}
      <ul className={`${listStyle} lg:gap-12`}>
        <li className={itemStyle}>
          <UKFlagIcon className='rounded-full w-7 h-7 xl:w-9 xl:h-9' />5 British Trade
          Missions
        </li>
        <li className={itemStyle}>
          <SeedrsLogoIcon className='w-7 h-7 xl:w-9 xl:h-9' />
          Republic (formerly Seedrs) Alumni
        </li>
        <li className={itemStyle}>
          <InnovateUKLogoIcon className='w-7 h-7 xl:w-9 xl:h-9' />
          £240k in grants awarded by Innovate UK
        </li>
      </ul>
    </div>
  )
}
